import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { MegaPromptName } from "@common/lib/chat-ai/mega-prompts";
import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { CareerValuationAuthService } from "../career-valuation-auth.service";
import { AnalyseCareerValuationTimelinePageComponent } from "./analyse-cvt-timeline-page.component";

const AnalyseCareerValuationTimelinePageTitle = "Analyse Timeline";

export const analyseCareerValuationTimelinePageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-analyse-career-valuation-timeline-page", AnalyseCareerValuationTimelinePageComponent)
    .atOrganisationUrl("/people/career-valuation/analyse-timeline")
    .redirectToThisRouteFromOrganisationUrl("/people/careerValuation/analyseTimline")
    .verifyingAccess(CareerValuationAuthService.ReadQuantitativeCareerValuation)
    .verifyingFeatures(FeatureName.CulturalNetworkCareerValuation)
    .withTitle(AnalyseCareerValuationTimelinePageTitle)
    .requiresLogin(true)
    .withMegaPrompt(MegaPromptName.CultureSentimentAnalysis)
    .withMegaPrompt(MegaPromptName.CareerValuationTrend)
    .withMegaPrompt(MegaPromptName.AnalyseEmployeesAtRisk)
    .withMegaPrompt(MegaPromptName.CareerValuationOverdue)
    .build();
